import React, { Component } from 'react';
import Link from '../../components/Link';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Flex, Box } from 'rebass';
import { Text } from '../../components_new/common';
import Button from '../../components_new/common/FormComponents/Button';
import styled from 'styled-components';
import { colors, text, base, lg } from '../../tailwind';
import { buildPhotoPath } from '../../helpers/photoutils';
// Redux
import { connect } from 'react-redux';

import { Grid, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ViewMessage.css';

// Component
import SendMessage from './SendMessage';
import ThreadItems from './ThreadItems';
import MessagingController from './../../components_new/messaging/MessagingController';
// Graphql
import GetMoreThreadItemsQuery from './GetMoreThreadItemsQuery.graphql';

//Mock
import moment from 'moment';

class ViewMessage extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.func,
    threadId: PropTypes.number.isRequired,
    userType: PropTypes.string.isRequired,
    threadItemsData: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      thread: PropTypes.shape({
        guestProfile: PropTypes.shape({
          profileId: PropTypes.number.isRequired,
          picture: PropTypes.string,
          displayName: PropTypes.string.isRequired,
          firstyName: PropTypes.string.isRequired,
          location: PropTypes.string,
          reviewsCount: PropTypes.number,
        }),
        guestUserData: PropTypes.shape({
          email: PropTypes.string.isRequired,
        }),
        hostProfile: PropTypes.shape({
          profileId: PropTypes.number.isRequired,
          picture: PropTypes.string,
          displayName: PropTypes.string.isRequired,
          firstyName: PropTypes.string.isRequired,
          location: PropTypes.string,
          reviewsCount: PropTypes.number,
        }),
        hostUserData: PropTypes.shape({
          email: PropTypes.string.isRequired,
        }),
        threadItemForType: PropTypes.shape({
          reservationId: PropTypes.number,
          startDate: PropTypes.string.isRequired,
          endDate: PropTypes.string.isRequired,
          personCapacity: PropTypes.number.isRequired,
          createdAt: PropTypes.string.isRequired,
          cancelData: PropTypes.shape({
            guestServiceFee: PropTypes.number,
            hostServiceFee: PropTypes.number,
            refundToGuest: PropTypes.number,
            payoutToHost: PropTypes.number,
            total: PropTypes.number,
            currency: PropTypes.string,
          }),
        }),
        listData: PropTypes.shape({
          title: PropTypes.string.isRequired,
          listingData: PropTypes.shape({
            basePrice: PropTypes.number.isRequired,
            cleaningPrice: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
          }),
        }),
      }),
    }),
  };

  static defaultProps = {
    threadId: null,
  };

  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.chatsBox.scrollTop = this.chatsBox.scrollHeight;
  };

  loadMore() {
    const {
      threadItemsData: {
        loading,
        getThread: { threadItems },
        fetchMore,
      },
      threadId,
    } = this.props;
    fetchMore({
      query: GetMoreThreadItemsQuery,
      variables: {
        threadId,
        offset: threadItems.length,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }
        return {
          getThread: {
            ...previousResult.getThread,
            threadItems: [
              ...previousResult.getThread.threadItems,
              ...fetchMoreResult.getAllThreadItems,
            ],
          },
        };
      },
    });
  }

  renderActions() {
    const {
      thread,
      thread: { reservation },
    } = this.props;

    if (reservation) {
      return (
        <React.Fragment>
          <Button secondary action style={{ minWidth: '128px' }} mb={3}>
            Accept
          </Button>
          <Button secondary muted style={{ minWidth: '128px' }}>
            Reject
          </Button>
        </React.Fragment>
      );
    }

    return null;
  }

  renderDateRange = reservation => {
    const startD = moment(reservation.checkIn);
    const endD = moment(reservation.checkOut);
    return (
      <div className="g g-tc-a-3 f-start g-g-sxx">
        <Text large>{startD.format('MMM D')}</Text>
        <Text large>-</Text>
        <Text large>
          {endD.format(startD.month() !== endD.month() ? 'MMM D' : 'D')}
        </Text>
      </div>
    );
  };

  userType = () => {
    const { thread, userId } = this.props;
    return (
      (thread && userId === thread.hostId && 'host') ||
      (thread && userId === thread.guestId && 'guest') ||
      'noaccess'
    );
  };

  render() {
    const {
      thread,
      userId,
      isAdminAuthenticated,
      thread: { listData },
      startApproval,
    } = this.props;
    const userType = this.userType();

    const threadId = thread.id;

    const reservation = thread.reservation;

    const userProfile =
      userType === 'host' ? thread.hostProfile : thread.guestProfile;
    const otherProfile =
      userType === 'host' ? thread.guestProfile : thread.hostProfile;

    const otherData =
      userType === 'host' ? thread.guestUserData : thread.hostUserData;

    const senderName = userProfile.firstName;
    const receiverType = userType === 'host' ? 'guest' : 'host';
    const receiverName = otherProfile.firstName;
    const receiverEmail = otherData.email;

    //These appear to not be used, but redux-form looks for this property and
    //initializes it's form when we pass them into SendMessage
    const initialValues = {
      threadId,
      threadType: userType,
      type: 'message',
      receiverName,
      senderName,
      receiverType,
      receiverEmail,
    };

    return (
      <React.Fragment>
        <Col md={9} style={{ marginLeft: '17px' }}>
          <Flex>
            <Text mb={5}>
              <Text bold lg>
                {otherProfile.displayName}
              </Text>
              <Text text base>
                Member since{' '}
                <Text inline bold>
                  {moment(otherProfile.createdAt).format('MMM YYYY')}
                </Text>
              </Text>
              <Link to={`/users/show/${otherProfile.profileId}`}>
                <Text link>See profile</Text>
              </Link>
            </Text>
          </Flex>
          <Box
            style={{ height: '45vh', overflowY: 'auto', overflowX: 'hidden' }}
            pr="20px"
            mb={3}
            innerRef={e => (this.chatsBox = e)}
          >
            <ThreadItems
              userType={userType}
              threadId={threadId}
              data={thread}
              loadMore={this.loadMore}
            />
          </Box>
          {!isAdminAuthenticated && (
            <SendMessage
              enableReinitialize
              initialValues={initialValues}
              threadId={threadId}
              profileId={userProfile.profileId}
              picture={userProfile.picture}
              displayName={userProfile.displayName}
            />
          )}
        </Col>
        {listData && (
          <Col md={3} ml={4} style={{ marginLeft: '17px', padding: '0px' }}>
            <ListingImage
              src={buildPhotoPath('x_medium', listData.coverPhotoName)}
            />
            <Box style={{ marginBottom: '25px' }}>
              <Text bold lg noclip>
                {listData.title}
              </Text>
              {reservation && reservation.checkIn && (
                <Box>
                  {this.renderDateRange(reservation)}
                  <Text bold lg mt="-4px">
                    $ {reservation.total}
                  </Text>
                </Box>
              )}
            </Box>
            <MessagingController
              userType={userType}
              thread={thread}
              reservation={reservation}
              startApproval={startApproval}
            />
          </Col>
        )}
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  isAdminAuthenticated: state.runtime.isAdminAuthenticated,
});

const mapDispatch = {};

export default compose(
  withStyles(s),
  connect(
    mapState,
    mapDispatch,
  ),
)(ViewMessage);

const ListingImage = styled.img`
  height: 127px;
  width: 127px;
  border-radius: 6px;
  object-fit: cover;
  margin-bottom: 25px;
`;

/*
Order by Date
Loop through
MESSAGE : SKIP
CHECKIN -> Leave a Review
CHECKOUT -> IGNORE (done in app)
APPROVED -> Check-out (inprogress) && CANCEL && GUEST -> Request Reschedule && GUEST -> "You've been approved"
RESCHEDULEREQUEST -> HOST -> approve/deny  (approve send another approve)
PENDING : GUEST -> Cancel HOST -> Approve/Deny.  
    TODO : Reservations make a thread instead of populating message in reservation table

INQUIRY : GUEST -> Make Reservation.  HOST -> LATER (Mark as answered/close)
*/

/*
RESERVATION STATES: 
pending - GUEST -> Makes reservation Request on request screeen
approved - HOST -> Approves booking
declined - HOST -> Denies booking
completed - GUEST -> Pickup
cancelled - HOST/GUEST -> Message screen or Reservation screen
expired - ?? Investigate how they did this
*/

/*
MESSAGE STATES
INQUIRY - Details screen, contact owner
MESSAGE - (chatting with reservation) - Message screen after reservation is made
DECLINED - Message screen & Reservations screen
APPROVED - Message screen 
PENDING - Make Reservation
RESCHEDULEREQUEST - 
CANCELLEDBYHOST - Message screen & Reservations screen
CANCELLEDBYGUEST - Message screen & Reservations screen
CHECKOUT - APP
CHECKIN - APP
COMPLETED (AFTER REVIEW) - REVIEW
EXPIRED - ?? Investigate
CONFIRMED - NOT used right now, will use for 'far away rentals later', should this be the default?



'message','inquiry','declined','approved','pending','cancelledByHost','cancelledByGuest','checkin','checkout','confirmed','expired','completed', 'reschedulerequest'
*/



// WEBPACK FOOTER //
// ./src/components/ViewMessage/ViewMessage.js